import _defineProperty from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { POSITION } from './constants';
import Box from './Box';
import theme from './theme';
import sx from './sx';
var Position = styled(Box).withConfig({
  displayName: "Position",
  componentId: "gj4o9g-0"
})(["", ";", ";"], POSITION, sx);
Position.defaultProps = {
  theme: theme
};
Position.propTypes = _objectSpread(_objectSpread(_objectSpread({}, Box.propTypes), POSITION.propTypes), {}, {
  theme: PropTypes.object
}, sx.propTypes);

function withPosition(position) {
  var WithPosition = function WithPosition(props) {
    return /*#__PURE__*/React.createElement(Position, _extends({}, props, {
      position: position.toLowerCase()
    }));
  };

  WithPosition.defaultProps = Position.defaultProps;
  WithPosition.displayName = "Position.".concat(position);
  return WithPosition;
}

export default Position;
export var Absolute = withPosition('Absolute');
export var Fixed = withPosition('Fixed');
export var Relative = withPosition('Relative');
export var Sticky = withPosition('Sticky');
Sticky.defaultProps = {
  theme: theme,
  top: 0,
  zIndex: 1
};